export function stripNonNumeric(text) {

    if (text) {
        return text.replace(/\D/g, '');
    }
    return null;
};